export default __webpack_public_path__ + "static/media/zabbix.929f76a9.png";